export default __webpack_public_path__ + "static/media/3.f4d26161.png";